export enum FeatureFlags {
  SiteMaintenance = 'gc_site_maintenance',
  ShowMaintenanceMessage = 'gc_show_maintenance_message',
  EnableThanksScript = 'gc_web_enable_thanks',
}
